/**
 * Styled Components - Created by eduardoquintero on 07/05/19.
 */
import styled from 'styled-components'

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 35em;
`

export const Container = styled.div`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`

export const HeaderSection = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  @media (max-width: 698px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const HeaderSectionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const HeaderSectionItemLabel = styled.div`
  font-weight: 600;
`

export const ContentArea = styled.div`
  display: flex;
  gap:10px;
  margin-top: 16px;
  height: 100vh;
  @media (max-width: 698px) {
    flex-direction: column;
    height: unset;
  }
`

export const ScrollableArea = styled.div`
  overflow-y: scroll;
  background-color: white;
  flex-grow: 2;
  display: flex;
  flex-wrap: wrap;
  column-gap: 42px;
  row-gap: 20px;
  padding-bottom: 32px;
  @media (max-width: 698px) {
    overflow-y: unset;
    overflow-x: scroll;
    flex-wrap: nowrap;
    column-gap: 22px;
    flex-grow: 1;
  }
`

export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
  border: 1px solid #bdbdbd;
  gap: 8px;
  margin: 0 -12px 0 0px;
  width: calc(50% - 20px);
  padding: 10px;
  height: fit-content;
  border-radius: 5px;
`
export const TileMedia = styled.div`
  display: flex;
  height: 150px;
  justify-content: space-between;
  color: white;
`

export const FixedArea = styled.div`
  background-color: white;
  flex-grow: 1;
  min-width: 40%;
  max-width: 40%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: 698px) {
    max-width: unset;
  }
`

export const Heading = styled.div`
  font-size: 14px;
  font-weight: 600;
`

export const ShowMoreButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 40%;
`

export const ShowMoreButton = styled.div`
  padding: 6px 10px;
  color: #4b99e6;
  border: 1px solid #4b99e6;
  border-radius: 3px;
  cursor: pointer;
`

export const MetricContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 42px;
  row-gap: 20px;
  padding: 12px;
`

export const MetricItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 40%;
`

export const MetricItemLabel = styled.div`
  font-size: 12px;
`

export const MetricItemValue = styled.div`
  font-size: 12px;
  font-weight: 600;
`

export const MetricHeading = styled.div`
  background-color: #f8f8f8;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  padding: 10px;
`

export const MetricHeadingLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
`

export const MeasureContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 44%;
`

export const MeasureItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
`

export const MeasureItemLabel = styled.span``

export const MeasureItemValue = styled.span`
  font-size: 12px;
  font-weight: 600;
`

export const GenderItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const GenderItemLabel = styled.div``

export const GenderItemValue = styled.div`
  font-size: 12px;
  font-weight: 600;
`

export const MeasureGenderContainer = styled.div`
  background-color: #f8f8f8;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  padding: 10px;
`

export const TileMediaItem = styled.img`
  width: calc(50% - 5px);
  object-fit: cover;
`

export const DateTimeLabel = styled.span`
  font-size: 10px;
`

export const UserDateContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const UserScanContainer = styled.div`
  padding: 10px;
  display: flex;
  justify-items: center;
  justify-content: space-between;
`

export const ScanContainer = styled.div`
  color: #4f4d4e;
  background-color: #f8f8f8;
  border-radius: 6px;
  padding: 6px 4px;
  width: fit-content;
`
export const ScanLabel = styled.span`
 margin: 6px;
 font-size: 10px;
`

export const PopoverImage = styled.img`
  width: 386px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecsDetails/styledComponents.tsx